import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  InputAdornment,
  Chip,
  MenuItem,
  Box,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AddIcon from "@mui/icons-material/Add";

const DayScheduleSelector = ({
  onAddDaySchedule,
  daysOfWeekOptions,
  existingDays = [],
}) => {
  const [selectedDay, setSelectedDay] = useState("");
  const [time, setTime] = useState("");
  const [times, setTimes] = useState([]);
  const [availableDays, setAvailableDays] = useState([...daysOfWeekOptions]);

  // Actualizar días disponibles cuando cambian los días existentes
  useEffect(() => {
    const usedDays = existingDays.map((day) => day.day);
    setAvailableDays(
      daysOfWeekOptions.filter((day) => !usedDays.includes(day.value))
    );
    if (selectedDay && usedDays.includes(selectedDay)) {
      setSelectedDay("");
    }
  }, [existingDays, daysOfWeekOptions, selectedDay]);

  const handleAddTime = () => {
    if (time && !times.includes(time)) {
      setTimes([...times, time]);
      setTime("");
    }
  };

  const handleRemoveTime = (timeToRemove) => {
    setTimes(times.filter((t) => t !== timeToRemove));
  };

  const handleAddDay = () => {
    if (selectedDay && times.length > 0) {
      onAddDaySchedule({
        day: selectedDay,
        times: [...times],
      });
      // Resetear el estado
      setTimes([]);
      setTime("");
    }
  };

  // Formatear hora para mostrar en formato 24h
  const formatTimeForDisplay = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = timeStr.split(":");
    return `${hours.padStart(2, "0")}:${minutes}`;
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", gap: 5 }}>
        <Box sx={{ display: "flex", gap: 4 }}>
          <TextField
            select
            label="Día de entrenamiento"
            value={selectedDay}
            onChange={(e) => setSelectedDay(e.target.value)}
            disabled={availableDays.length === 0}
            sx={{ width: 220 }}
          >
            {availableDays.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
            {availableDays.length === 0 && (
              <MenuItem disabled>Todos los días agregados</MenuItem>
            )}
          </TextField>
        </Box>
        <Box sx={{ display: "flex", gap: 3 }}>
          <TextField
            fullWidth
            label="Horario"
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              step: 300, // incrementos de 5 minutos
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccessTimeIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    variant="text"
                    onClick={handleAddTime}
                    disabled={!time}
                    startIcon={<AddIcon />}
                  >
                    Agregar
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      {times.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
          {times.map((time, index) => (
            <Chip
              key={index}
              label={formatTimeForDisplay(time)}
              onDelete={() => handleRemoveTime(time)}
            />
          ))}
        </Box>
      )}
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleAddDay}
          disabled={!selectedDay || times.length === 0}
          sx={{
            height: "56px",
            width: 150,
            backgroundColor: "#e7ef7d",
            "&:hover": {
              backgroundColor: "#d4dc6d",
            },
          }}
        >
          Guardar Día
        </Button>
      </Box>
    </Box>
  );
};

export default DayScheduleSelector;
